export default __webpack_public_path__ + "static/media/never-lose-sight@2x.15eb3934.png";